import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['click']

  changeType() {
    this.clickTargets.forEach(target => target.click())
  }
}
